import React from 'react'
import styled from '@emotion/styled'
import { Helmet } from '@dr.pogodin/react-helmet'

import { CardContent, Grid, Card as MuiCard, Divider as MuiDivider, Typography } from '@mui/material'
import { spacing } from '@mui/system'

const Card = styled(MuiCard)(spacing)

const Divider = styled(MuiDivider)(spacing)

function EmptyCard() {
    return (
        <Card mb={6}>
            <CardContent>
                <Typography variant='h6' gutterBottom>
                    Rapporter
                </Typography>
                <Typography variant='body2' gutterBottom>
                    <p>
                        Du når oss på <a href='mailto:info@financelab.se'>info@financelab.se</a>.
                    </p>
                </Typography>
            </CardContent>
        </Card>
    )
}

function Reports() {
    return (
        <React.Fragment>
            <Helmet title='Rapporter' />
            <Typography variant='h3' gutterBottom display='inline'>
                Rapporter
            </Typography>

            <Divider my={6} />

            <Grid container spacing={6}>
                <Grid size={12}>
                    <EmptyCard />
                </Grid>
            </Grid>
        </React.Fragment>
    )
}

export default Reports
